// extracted by mini-css-extract-plugin
export default {"image":"HomePage_image__TnCdE","landingText":"HomePage_landingText__PwPAX"};